package com.schoolconnect.app.feature.common

import com.schoolconnect.app.util.scLog
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

internal class AdminBootstrapSequencer(
    private val scope: CoroutineScope,
    private val tag: String
) {
    private var bootstrapJob: Job? = null
    private var pageJob: Job? = null
    private var pendingPageReload: Boolean = false
    private var pendingPageForceRemote: Boolean = false

    fun clear() {
        bootstrapJob?.cancel()
        pageJob?.cancel()
        pendingPageReload = false
        pendingPageForceRemote = false
    }

    fun startBootstrap(
        forceRemote: Boolean,
        onAnalytics: suspend () -> Unit,
        onPage: suspend (Boolean) -> Unit
    ) {
        bootstrapJob?.cancel()
        pageJob?.cancel()
        pendingPageReload = true
        pendingPageForceRemote = pendingPageForceRemote || forceRemote
        bootstrapJob = scope.launch {
            scLog("$tag bootstrap start forceRemote=$forceRemote")
            // The list endpoint owns its filtered total count. Analytics is a
            // summary-card concern and must not delay the first page.
            launch { onAnalytics() }
            flushPendingPageReload(onPage)
        }
    }

    fun shouldDeferPageReload(
        forceRemote: Boolean,
        analyticsLoading: Boolean,
        hasAnalytics: Boolean
    ): Boolean = false

    fun queuePageReload(
        forceRemote: Boolean,
        reason: String = "queued"
    ) {
        pendingPageReload = true
        pendingPageForceRemote = pendingPageForceRemote || forceRemote
        scLog("$tag pageReload $reason forceRemote=$forceRemote")
    }

    fun launchPage(
        forceRemote: Boolean,
        onPage: suspend (Boolean) -> Unit
    ) {
        pageJob?.cancel()
        pageJob = scope.launch {
            scLog("$tag pageLoad start forceRemote=$forceRemote")
            onPage(forceRemote)
        }
    }

    private suspend fun flushPendingPageReload(
        onPage: suspend (Boolean) -> Unit
    ) {
        if (!pendingPageReload) return
        val forceRemote = pendingPageForceRemote
        pendingPageReload = false
        pendingPageForceRemote = false
        scLog("$tag bootstrap page start forceRemote=$forceRemote")
        onPage(forceRemote)
    }
}
